interface EditableRowInfoProps {
  label: string
  value?: string

  children?: React.ReactNode
}

function EditableRowInfo(props: EditableRowInfoProps) {
  return (
    <div className="flex justify-between">
      <div className="flex flex-col gap-0">
        <h3 className="text-sm font-medium">{props.label}</h3>
        <p className="text-sm text-secondary">{props.value}</p>
      </div>
      {props.children}
    </div>
  )
}

export default EditableRowInfo
